import { Iterable } from 'immutable';
import StackTrace from 'stacktrace-js';
import log from 'loglevel';

/**
 * Determines whether the given object is an immutable exception.
 *      i.e. an immutable Map with a type attribute
 */
export const isImmutableException = exc => Iterable.isIterable(exc) && exc.get('type');

/**
 * Determines whether the given object is a Sparx Web server exception.
 *      i.e. an immutable Map with the fromServer flag set
 */
export const isServerException = exc => isImmutableException(exc) && exc.get('fromServer');

/**
 * Takes an exception of any type and returns an object containing:
 * {
 *     name - a short description of the exception (string)
 *     message - a longer description of the exception (string)
 *     frames - a stack trace (string)
 *     reportToServer - should the exception be reported to the server (bool)
 * }
 */
export function* parseException(exc) {
    const result = {
        name: '',
        message: '',
        frames: '',
        reportToServer: true,
        category: '',
    };

    if (isImmutableException(exc)) {
        // If the exception is immutable.
        result.name = exc.get('name', 'UnnamedException');
        result.message = exc.get('message', 'No message.');
        // Don't report the error to the server if it was thrown by the server.
        result.reportToServer = !isServerException(exc);
        result.category = 'custom';
    } else if (typeof exc === 'string') {
        // If the exception is a string.
        result.name = exc;
        result.category = 'custom-string';
    } else {
        // If it's a normal exception.
        result.name = exc.name;
        result.message = exc.message;
        result.category = exc.swErrorCategory || 'unknown';

        try {
            const stack = yield StackTrace.fromError(exc);
            result.frames = stack.map(frame => frame.toString());
        } catch (e) {
            log.error("Couldn't parse Stack Trace from Error: ", e);
        }
    }

    return result;
}
